import { Alert, Button, Modal } from '@payaca/ambrosia';
import { FC, useState, type JSX } from 'react';

import useMarkIndirectPurchaseOrderAsSent from '../../../../api/mutations/purchaseOrders/useMarkIndirectPurchaseOrderAsSent';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  purchaseOrderId: number;
  onMarkAsSentSuccess?: () => void;
};

const MarkIndirectPurchaseOrderAsSentModalContent: FC<Props> = (
  props
): JSX.Element => {
  const { onClose, purchaseOrderId, onMarkAsSentSuccess } = props;
  const markIndirectPurchaseOrderAsSent = useMarkIndirectPurchaseOrderAsSent({
    onSuccess: () => onMarkAsSentSuccess?.(),
  });
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onMarkAsSent = async () => {
    const result = await markIndirectPurchaseOrderAsSent.mutateAsync({
      purchaseOrderId: purchaseOrderId.toString(),
    });
    if (
      result.markIndirectPurchaseOrderAsSent.__typename ===
      'MarkIndirectPurchaseOrderAsSentSuccess'
    ) {
      onClose();
    } else {
      setErrorMessage(
        result.markIndirectPurchaseOrderAsSent.message ||
          'An error occurred while marking the Purchase Order as sent.'
      );
    }
  };

  return (
    <>
      <Modal.Body>
        <p>
          Purchase order will be marked as sent but we will not send any emails
          to the Supplier.
        </p>
        {errorMessage ? (
          <Alert colour="red" className="mt-2">
            {errorMessage}
          </Alert>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            onClick={onMarkAsSent}
            isProcessing={markIndirectPurchaseOrderAsSent.isPending}
          >
            Mark as sent
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </>
  );
};

const MarkIndirectPurchaseOrderAsSentModal: FC<Props> = (
  props
): JSX.Element => {
  return (
    <Modal isOpen={props.isOpen} title="Mark as sent" onClose={props.onClose}>
      <MarkIndirectPurchaseOrderAsSentModalContent {...props} />
    </Modal>
  );
};

export default MarkIndirectPurchaseOrderAsSentModal;
